import { type ChilizOrTokenCardProps, getChilizCardProps } from '@capsicum/features/nc-wallet/shared';
import { match } from 'ts-pattern';

import { useNCWPartnerRouting } from '../../hooks';
import { NCWalletTokenListCard } from '../../ui/nc-wallet-token-list-card';

/**
 * This component is solely used by NCWPartnerDetails, to render either a ChilizCard or a TokenCard
 * @param {NCWTokenBalanceType} chilizBalance The chiliz balance
 * @param {boolean} isPending Whether the data is pending from BE
 * @param {string} tokenShortCode The token short code. e.g. CHZ, ACM.
 * @param {() => void} getTokenBalanceBy The callback to retrieve specific token balance
 * @returns {JSX} Either a ChilizCard or a TokenCard
 */
export const ChilizOrTokenCard = ({
	chilizBalance,
	getTokenBalanceBy,
	isPending,
	tokenShortCode
}: ChilizOrTokenCardProps) => {
	const { routeToPartnerPage } = useNCWPartnerRouting();

	if (isPending) {
		return <NCWalletTokenListCard isLoading />;
	}

	const renderChilizCard = () =>
		chilizBalance ? <NCWalletTokenListCard {...getChilizCardProps(chilizBalance.tokenCardData)} /> : null;

	const renderTokenCard = () => {
		const tokenBalance = getTokenBalanceBy(tb => tb.shortCode === tokenShortCode);

		return tokenBalance ? (
			<NCWalletTokenListCard
				{...tokenBalance.tokenCardData}
				onIconClick={() => routeToPartnerPage(tokenBalance.currencyId)}
			/>
		) : null;
	};

	return match(tokenShortCode)
		.with('CHZ', () => renderChilizCard())
		.otherwise(() => renderTokenCard());
};
